import React, {useContext, useEffect} from "react";
import {Col, Form, Input, Row} from "antd";
import {useTranslation} from "react-i18next";
import {FileUploader} from "../../../../core/commons/file-uploader/file-uploader";
import {useForm} from "antd/es/form/Form";
import {StepperContext, StepperContextValue} from "../../../../core/commons/stepper/stepper";
import {CreateClaimItem} from "../../../../../models/claims/claims";
import {claimService} from "../../../../../services/claims/claims.service";

export const DescriptionStep: React.FC = () => {

    const ctx = useContext<StepperContextValue<CreateClaimItem>>(StepperContext);

    const [form] = useForm();

    const { t } = useTranslation("translation", { useSuspense: false });

    useEffect(() => {
        ctx.setOnStepComplete(async () => {
            await form.validateFields();
            form.submit();
        })
    }, [ctx, form]);

    return (
        <Form
            form={form}
            initialValues={ctx.data}
            layout="vertical"
            onFinish={values => {
                ctx.data.data!.description = values.description;
                ctx.data.data!.images = values.images;
            }}
        >
            <Row gutter={10}>
                <Col span={24}>
                    <Form.Item
                        label={t('DESCRIPTION')}
                        name={['description']}
                        rules={[{ required: true }]}
                    >
                        <Input.TextArea style={{height: 140}} />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={10}>
                <Col span={24}>
                    <Form.Item
                        label="Attachments"
                        name={['images']}
                    >
                        <FileUploader
                            upload={(file: File) => claimService.uploadFile(file)}
                            onRemove={file => claimService.removeFile(parseInt(file.uid))}
                        />
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    )
}